/* eslint-disable */
import React, { Component } from "react";
import FieldsContainer from "../FieldsContainerBB/FieldsContainer";
import { Box } from "@chakra-ui/react";

export default class MiddleMenu extends Component<any> {
  render() {
    const {
      Surveys: { enums, values },
    } = this.props;
    return (
      <Box
        overflowY="scroll"
        maxHeight="85vh"
        w={["100%", "100%", "80%"]}
        mx="auto"
        id="middle-menu"
      >
        {this.props.Surveys?.sections?.map((sec: any, i: number) => {
          sec.questions.length &&
            sec.questions.map((q: any) => (
              <FieldsContainer
                config={this.props.config}
                id={q.id}
                key={q.id + "-middle_menu"}
                data={sec}
                enums={enums}
                index={sec.questions.indexOf(q) + 1}
              />
            ));
        })}
        {this.props.Surveys?.sections?.map((sec: any, i: number) =>
          sec.subSection.map((sub: any) => (
            <FieldsContainer
              config={this.props.config}
              id={sub.id}
              key={sub.id + "-middle_menu"}
              data={sub}
              enums={enums}
              index={sec.subSection.indexOf(sub) + 1}
            />
          ))
        )}
        <Box h="50vh" maxHeight="85vh" />
      </Box>
    );
  }
}
